import React from 'react';
import HeadingBlock from '$/components/global/heading';
import TranscriptsGrid from '$/components/transcripts-grid';

const Transcripts: React.FC<any> = () => {
  return (
    <React.Fragment>
      <section>
        <div>
          <HeadingBlock title={'Manage Transcriptions'} />
          <TranscriptsGrid />
        </div>
      </section>
    </React.Fragment>
  );
};

export default Transcripts;
